// @flow

export const MINUTE: number = 60;
export const HOUR: number = MINUTE * 60;
export const DAY: number = HOUR * 24;
export const MONTH: number = DAY * 30;
export const YEAR: number = MONTH * 12;
